<template>
  <badge :loading="false" :type="statusType" :text="statusText"></badge>
</template>


<script>
import Badge from "@/components/Badge";

export default {
  props: ["status"],

  components: { Badge },

  data() {
    return {
      statusTypes: {
        draft: {
          type: "info",
          text: "Entwurf"
        },
        live: {
          type: "success",
          text: "Veröffentlicht"
        },
        completed: {
          type: "info",
          text: "Abgerechnet"
        },
        cancelled: {
          type: "default",
          text: "Abgesagt"
        },
        ended: {
          type: "info",
          text: "Vorbei"
        }
      },
      statusType: "",
      statusText: ""
    };
  },

  watch: {
    status: {
      handler: function() {
        this.statusType = this.statusTypes[this.status].type;
        this.statusText = this.statusTypes[this.status].text;
      },
      immediate: true
    }
  }
};
</script>
